// @flow
import React, { Component } from 'react';
import type { ComponentType } from 'react';

type Props = Object;
type State = {
  errors: Object,
  touched: Object,
};

const withValidation = (validations: Object) => (WrappedComponent: ComponentType<any>) =>
  class Form extends Component<Props, State> {
    _isMounted: boolean;

    constructor(props: Props) {
      super(props);

      this.state = {
        errors: {},
        touched: {},
      };
    }

    componentDidMount() {
      this._isMounted = true;
    }

    componentWillUnmount() {
      this._isMounted = false;
    }

    onValidate = ({ name }: { name: string }) => {
      // FIXME: delay the thread, but we can do better
      setTimeout(() => {
        const { touched } = this.state;
        const shouldValidate = typeof this.props[name] !== 'undefined';

        if (name && shouldValidate) {
          touched[name] = true;

          if (this._isMounted) {
            this.setState({ touched });
            this.validate();
          }
        }
      }, 0);
    };

    validate = ({ checkTouch }: { checkTouch?: boolean } = { checkTouch: true }): Object => {
      const errors: Object = {};
      const touched: Object = {};
      const newState: { errors: Object, touched?: Object } = { errors };

      Object.keys(validations).forEach((key: string) => {
        if (checkTouch) {
          if (!this.state.touched[key]) {
            return;
          }
        } else {
          touched[key] = true;
        }

        const validator = validations[key];
        const value = this.props[key];

        const phase1 = validator(value, this.props);
        const phase2 = typeof phase1 === 'function' ? phase1(value, this.props) : phase1;

        errors[key] = typeof phase2 === 'function' ? phase2(value) : phase2;
      });

      if (Object.keys(touched).length) {
        newState.touched = touched;
      }

      this.setState(newState);

      return errors;
    };

    render() {
      const { errors } = this.state;

      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onValidateAll={this.validate}
          onValidate={this.onValidate}
          errors={errors}
          hasError={!!Object.keys(errors).find(key => !!errors[key])}
        />
      );
    }
  };

export default withValidation;
